import { useMutation } from '@tanstack/react-query'

import { queryClient, setQueriesData, setQueryData } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { mapCache, QK } from '@shared/utils'

export function useMarkCompleted(taskId) {
  return useMutation({
    mutationFn: (reason) => API.tasks.id(taskId).mark.completed({ reason }),
    onSuccess: updateCache,
  })
}

export function useMarkNotApplicable(taskId) {
  return useMutation({
    mutationFn: (reason) => API.tasks.id(taskId).mark.notApplicable({ reason }),
    onSuccess: updateCache,
  })
}

export function useMarkExpired(taskId) {
  return useMutation({
    mutationFn: (reason) => API.tasks.id(taskId).mark.expired({ reason }),
    onSuccess: updateCache,
  })
}

export function useTaskNoteCreation(taskId) {
  return useMutation({
    mutationFn: (message) => API.tasks.id(taskId).notes.create({ message }),
  })
}

const updateCache = (updatedTask) => {
  setQueryData(QK.patients.id(updatedTask.patientId).tasks.id(updatedTask.id).details, (task = {}) => ({ ...task, ...updatedTask }))
  setQueriesData(
    { queryKey: QK.patients.id(updatedTask.patientId).tasks.lists },
    mapCache((task) => (task.id === updatedTask.id ? { ...task, ...updatedTask } : task))
  )
  queryClient.invalidateQueries({ queryKey: QK.tasks.lists })
}
